module.exports = __webpack_public_path__ + "static/media/main-banner.337e9436.png";